import styled, { css } from "react-emotion";

import { flex } from "appStyles";

export const container = css`
  position: relative;
`;
export const itemOptionRow = css`
  padding: 10px 0px;
  border-bottom: 1px solid lightgray;
  &:last-child {
    border-bottom: none;
  }
`;
export const storeRow = css`
  width: 45rem;
  border: 1px solid rgba(200, 200, 200, 0.4);
  padding: 1rem;
  margin: 2rem;
`;
export const formStyle = css`
  position: relative;
  padding: 20px;
  background: #dfe5e6;
  border-radius: 0px 0px 5px 5px;
`;

export const FloatingIconTopRight = styled("div")`
  position: sticky;
  justify-content: flex-end;
  display: flex;
  align-items: center;
  right: 10px;
  top: 10px;
  z-index: 10;
  margin-bottom: 10px;
`;

export const mobileFormStyle = css`
  position: relative;
  padding: 10px;
  background: #dfe5e6;
  border-radius: 0px 0px 5px 5px;
`;
export const boldButton = css`
  display: inline-block;
  width: 100px;
  text-align: center;
  border-radius: 5.5px;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-transform: none;
`;

export const storeButton = css`
  ${flex};
  margin: 2rem;
  position: relative;
  padding: 0.4rem;
  background: white;
  border: 2px solid rgba(100, 100, 100, 1);
  border-radius: 0.4rem;
  color: black;
  width: 10rem;
  cursor: pointer;
`;

export const textArea = css`
  margin-top: 3rem;
  resize: none;
  width: 40rem;
  min-height: 7rem;
  background: none;
  color: white;
  font-size: 1.5rem;
  outline: none;
  box-shadow: none;
  border: 1px solid rgba(100, 180, 200, 0.7);
  padding: 1rem;
  transition: 0.4s;

  &:hover {
    border-color: aqua;
    transition: 1s;
  }
`;

export const H2 = styled("h2")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  line-height: 18px;
  color: #1f3747;
  margin: auto;
`;

export const buttonStyle = css`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-transform: none;
  box-shadow: 3px 3px 13px rgba(120, 120, 120, 0.5);
  display: inline-flex;
  align-items: center;
  border-radius: 5.5px;
`;

export const selectStyle = css`
  padding: 0px;
  text-align: center;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  cursor: pointer;
  color: black;
  width: 85px;
  font-size: 15px;
  text-align: left;
  padding-left: 5px;
  border: 0px;
  outline: 0px;
  border: 1px solid #979797;

  select::-ms-expand {
    display: block;
  }
  /* Removes the default <select> styling */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  /* Positions background arrow image */
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAA20lEQVQ4T+3SL0tDcRjF8c8V2YrJqHF1VTAIK5rtewGCb2BNWBIcmKy+gYW9ATGJIPblwZLNZBqMyQ9+Vy4/7j/wxj31Oc8XzjlPpuPJOubZA/+faJphDxPMsGnA96P2oahNgUd4xRpjbCugh5jjFJf4yXVlLR/jDR+4wS6BHuAZZxjhu7ivepsTvGMRbeXQoH/ENS7wlTqo+8NBhD7hPh7e4TbCVmVxND32MNoPoGB1Gm0uqwprAoa7c7xEwBU+69pvAwz3ockw4QNqpy2wifO33wNbR1Up7DzDX2zcHRV0yPnBAAAAAElFTkSuQmCC");
  background-repeat: no-repeat;
  background-position: 60px center;
`;
export const inputStyle = css`
  width: 30%;
  border: none;
  border: 1px solid #979797;
  background: none;
  outline: none;
  margin: 0 0 10;
  box-shadow: none;
  /* margin-top: 20px; */
  padding: 6px 10px;
  color: #1f3747;
  font-size: 15px;
  box-sizing: border-box;
  border-radius: 3px;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;

  &:hover,
  :focus {
    border-color: #aed9da;
    opacity: 1;
    transition: opacity 0.4s;
  }

  &::placeholder {
    color: grey;
    font-size: 1rem;
    opacity: 0.8;
    margin: 5px;
  }
`;

export const mobileInputStyle = css`
  width: 100%;
  border: none;
  border: 1px solid #979797;
  background: none;
  outline: none;
  margin: 0 0 10;
  box-shadow: none;
  /* margin-top: 20px; */
  padding: 6px 10px;
  color: #1f3747;
  font-size: 15px;
  box-sizing: border-box;
  border-radius: 3px;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;

  &:hover,
  :focus {
    border-color: #aed9da;
    opacity: 1;
    transition: opacity 0.4s;
  }

  &::placeholder {
    color: grey;
    font-size: 1rem;
    opacity: 0.8;
    margin: 5px;
  }
`;

export const SectionContainer = css`
  box-shadow: 3px 3px 13px rgba(120, 120, 120, 0.5);
  background-color: white;
  padding: 1.5em;
  border-radius: 5px;
  margin-bottom: 2em;
  width: 100%;
`;

export const MobileSectionContainer = css`
  box-shadow: 3px 3px 13px rgba(120, 120, 120, 0.5);
  background-color: white;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 2em;
  width: 100%;
`;

export const P = styled("p")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: "white";
  display: block;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
`;
